import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import Aux from '../../hoc/Aux';
import { useForm } from 'react-hook-form'
import * as actions from '../../store/actions/index';
import Navigation from './Navigation';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import { useParams } from "react-router";
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';

const projectContact = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const alert = useAlert();
  const ct = useCustomTranslation();
  let { projectId } = useParams();

  const loading = useSelector(state => state.inventory.loading_project );

  const { register, handleSubmit } = useForm();

  const onSubmit = data => {
    data = {...data, id: projectId}
    dispatch( actions.updateProject(data) ).then( (res) => {
      alert.show('Daten wurden gespeichert', {type: "success"});
     });
  };

  const thisProject = useSelector(state => {
    return (projectId) => actions.getProject(state, projectId)
  });

  let project = thisProject(projectId) || {};

  const intialValues = {
    contact_name: project["contact_name"],
    contact_company: project["contact_company"],
    contact_phone: project["contact_phone"],
    contact_email: project["contact_email"]
  };


  if ( !loading || project !== {}) {
    project = thisProject(projectId) || {};

    return (

    <Aux>
    	<div className="main-container">
    		<div className="container">
    			<div className="row justify-content-center mt-5">
           <div className="col-xl-11 col-lg-11">
    					<div className="page-header">
              <h1 style={{fontSize: "1.0rem"}}>
                <span id="backlink"><Link to={ROUTES.TO_PROJECTS}>{ ct('project.navi.link.my_projects') }</Link></span> <i className="material-icons" style={{margin: "-5px", verticalAlign: "middle"}}>keyboard_arrow_right</i> {project.title}
              </h1>
    						<span className="lead"></span>
    					</div>
    				</div>
    			</div>
    			<div className="row justify-content-center mt-3">
            <div className="col-xl-3 col-lg-3 mb-10">
              <Navigation activeItem="project_contact_data" projectId={projectId} />
    				</div>

    				<div className="col-xl-8 col-lg-8 mb-10">
    					<div className="card">
    						<div className="card-body">
    							<div className="tab-content">
    								<div className="tab-pane fade show active" role="tabpanel" id="userdata">
    									<h4>{ ct('account.navigation.to_contact_person') }</h4>
                      <form onSubmit={handleSubmit(onSubmit)}>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.contact_name.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="contact_name"
                              defaultValue={intialValues.contact_name}
                              ref={register({ required: true, maxLength: 20 })} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.contact_company.label') }</label>
    											<div className="col">
    												<input
                              className="form-control"
                              name="contact_company"
                              defaultValue={intialValues.contact_company}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.contact_phone.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="contact_phone"
                              defaultValue={intialValues.contact_phone}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.contact_email.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="contact_email"
                              defaultValue={intialValues.contact_email}
                              ref={register()} />
                          </div>
    										</div>




    										<div className="row justify-content-end">
    											<button type="submit" className="btn btn-primary btn-project">{ ct('userprofile.form.button.submit') }</button>
    										</div>
    									</form>
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </Aux>
  )
} else {
 return null;
}


};

export default projectContact;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectContact.js